import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { Components as FooterComponents } from './footer.style';
const Footer = _ref => {
  let {
    footerData,
    stickyFooter
  } = _ref;
  const handleTextAlign = header => {
    if ((header === null || header === void 0 ? void 0 : header.colSpan) > 1) {
      return 'center';
    }
    if ((header === null || header === void 0 ? void 0 : header.column.columnDef.type) === 'number') {
      return 'right';
    }
    return 'left';
  };
  return _jsx(FooterComponents.TFoot, {
    children: footerData && footerData.map(footerGroup => _jsx("tr", {
      children: footerGroup.headers.map(header => header.column.columnDef.footer && _jsx(FooterComponents.Td, _extends({
        alignText: handleTextAlign(header),
        colSpan: header.column.columnDef.footerSpan,
        stickyColumn: stickyFooter && header.column.columnDef.meta && header.column.columnDef.meta.stickyColumn,
        stickyFooter: stickyFooter
      }, {
        children: header.isPlaceholder ? null : header.column.columnDef.footer ? flexRender(header.column.columnDef.footer, header.getContext()) : null
      }), header.id))
    }, footerGroup.id))
  });
};
export default Footer;